import instance from './instance';

export interface CreateContactRequestData {
  phone: string;
  okedCode: string | null;
  katoCode: string | null;
}

export function createContactRequest(
  data: CreateContactRequestData
): Promise<void> {
  return instance()
    .post('/contact-requests/create', data)
    .then((response) => response.data);
}

export interface CreateContactRequestWebData {
  phone: string;
  okedCode: string;
  katoCode: string;
  isSupplier: boolean;
}

export function createContactRequestWeb(
  data: CreateContactRequestWebData
): Promise<void> {
  return instance()
    .post('/contact-requests/create-web', data)
    .then((response) => response.data);
}
